export var drivingMarketList = {
    gain: "Top Gainers",
    loss: "Top Losers",
    highOiGainer: "Highest OI Gainers",
    highOiLoser: "Highest OI Losers",
    highRollover: "Highest Rollover",
    lowRollover: "Lowest Rollover",
    highPremium: "Highest Premium",
    highDiscount: "Highest Discount",
    activeVolume: "Most Active By Volume",
    activeValue: "Most Active By Value",
};
export var words = ["Zero", "One", "Two", "Three", "Four", "Five"];
export var drivingMarketMsg = function (count, section) {
    return "only ".concat(words[count], " stocks are at ").concat(drivingMarketList[section]);
};
export var SecurityBanList = {
    securities: "securities ban today",
    possibleEntrance: "Possible Entrance",
    possibleExits: "Possible Exits",
};
export var SecurityFNOBanMessage = function (count, section) {
    if (count === 0)
        return "No stocks are at ".concat(SecurityBanList[section], " today");
    return "Only ".concat(words[count].toLowerCase(), " ").concat(count === 1 ? "stock is" : "stocks are", " at ").concat(SecurityBanList[section]);
};
